import React from "react";
import { Row } from "../Grid";

const RecommendedResourcesPost = ({ ...props }) => {
	return <Row mx my {...props} />;
};

RecommendedResourcesPost.propTypes = {
	...Row.propTypes,
};

export default RecommendedResourcesPost;
